(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adoption-grid"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll(".hh-adopt-grid").forEach((root) => {
      const chips = root.querySelectorAll("[data-filter]");
      const cards = Array.from(root.querySelectorAll(".hh-adopt-card"));
      const live = root.querySelector("[data-hh-adoption-live]");
      const none = root.querySelector("[data-hh-adoption-none]");

      const counts = { all: cards.length, available: 0, pending: 0, adopted: 0 };
      cards.forEach((card) => {
        const s = card.dataset.status;
        if (counts[s] != null) counts[s] += 1;
      });
      root.querySelectorAll("[data-count-for]").forEach((el) => {
        const key = el.getAttribute("data-count-for");
        if (counts[key] != null) el.textContent = counts[key];
      });

      const apply = (f) => {
        let shown = 0;
        cards.forEach((card) => {
          const show = f === "all" || card.dataset.status === f;
          card.classList.toggle("is-hidden", !show);
          if (show) shown += 1;
        });
        if (none) none.hidden = shown !== 0;
        if (live) {
          const label = f === "all" ? "all" : f;
          live.textContent =
            shown === 0
              ? `No ${label} housemates right now.`
              : `Showing ${shown} ${label} ${shown === 1 ? "housemate" : "housemates"}.`;
        }
      };

      chips.forEach((c) =>
        c.addEventListener("click", () => {
          const f = c.dataset.filter;
          chips.forEach((x) => {
            const active = x === c;
            x.classList.toggle("is-active", active);
            x.setAttribute("aria-pressed", String(active));
          });
          apply(f);
        }),
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heros = document.querySelectorAll("[data-hh-hero]");
    if (!heros.length) return;
    const prefersReduce = () => window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;
    const canHover = () => window.matchMedia?.("(hover: hover) and (pointer: fine)").matches;

    heros.forEach((root) => {
      /* ---- Gallery crossfade + dots + progress + counter ---- */
      const frames = Array.from(root.querySelectorAll(".hh-hero__frame"));
      const dots = Array.from(root.querySelectorAll(".hh-hero__dot"));
      const progFill = root.querySelector("[data-hh-progress]");
      const counterEl = root.querySelector("[data-hh-counter-current]");
      if (frames.length > 1) {
        const interval = parseInt(getComputedStyle(root).getPropertyValue("--hero-interval")) || 5200;
        let idx = 0,
          timer;
        const pad2 = (n) => String(n).padStart(2, "0");
        const restartProgress = () => {
          if (!progFill) return;
          progFill.style.animation = "none";
          // Force reflow so re-applied animation restarts
          progFill.offsetWidth;
          progFill.style.animation = "";
        };
        const setActive = (i) => {
          idx = (i + frames.length) % frames.length;
          frames.forEach((f, n) => f.classList.toggle("is-active", n === idx));
          dots.forEach((d, n) => {
            d.classList.toggle("is-active", n === idx);
            d.setAttribute("aria-selected", String(n === idx));
          });
          if (counterEl) {
            // Subtle vertical flip: out, swap text, in.
            if (prefersReduce()) {
              counterEl.textContent = pad2(idx + 1);
            } else {
              counterEl.classList.add("is-flipping");
              setTimeout(() => {
                counterEl.textContent = pad2(idx + 1);
                counterEl.classList.remove("is-flipping");
              }, 220);
            }
          }
          restartProgress();
        };
        const schedule = () => {
          if (prefersReduce()) return;
          clearTimeout(timer);
          timer = setTimeout(() => {
            setActive(idx + 1);
            schedule();
          }, interval);
        };
        dots.forEach((d, n) =>
          d.addEventListener("click", () => {
            setActive(n);
            schedule();
          }),
        );
        const stage = root.querySelector(".hh-hero__stage");
        if (stage) {
          stage.addEventListener("mouseenter", () => {
            clearTimeout(timer);
            if (progFill) progFill.style.animationPlayState = "paused";
          });
          stage.addEventListener("mouseleave", () => {
            if (progFill) progFill.style.animationPlayState = "";
            schedule();
          });
        }
        schedule();
      }

      /* ---- Drag-to-scrub gallery ---- */
      const galleryFrames = Array.from(root.querySelectorAll(".hh-hero__frame"));
      const stage = root.querySelector(".hh-hero__stage");
      if (stage && galleryFrames.length > 1 && !prefersReduce()) {
        let dragStartX = 0;
        let dragActive = false;
        let currentIdx = 0;
        const advance = (delta) => {
          const btn = root.querySelector(
            `[data-hh-dot="${(currentIdx + delta + galleryFrames.length) % galleryFrames.length}"]`,
          );
          if (btn) btn.click();
        };
        stage.addEventListener("pointerdown", (e) => {
          if (e.pointerType === "mouse" && e.button !== 0) return;
          dragActive = true;
          dragStartX = e.clientX;
          stage.classList.add("is-dragging");
          currentIdx = galleryFrames.findIndex((f) => f.classList.contains("is-active"));
        });
        const onUp = (e) => {
          if (!dragActive) return;
          dragActive = false;
          stage.classList.remove("is-dragging");
          const dx = e.clientX - dragStartX;
          if (Math.abs(dx) > 50) {
            advance(dx < 0 ? 1 : -1);
          }
        };
        stage.addEventListener("pointerup", onUp);
        stage.addEventListener("pointerleave", onUp);
      }

      /* ---- Colorway swatches ---- */
      const swatches = Array.from(root.querySelectorAll("[data-hh-swatch]"));
      if (swatches.length) {
        const frameColors = galleryFrames.map((f) => f.dataset.color || "");
        // Seed active swatch from the first frame's colour, if set
        const initialColor = frameColors[0];
        if (initialColor) {
          swatches.forEach((s) => {
            const is = s.dataset.hhSwatch === initialColor;
            s.classList.toggle("is-active", is);
            s.setAttribute("aria-checked", is ? "true" : "false");
          });
        }
        const setSwatchActive = (color) => {
          swatches.forEach((s) => {
            const is = s.dataset.hhSwatch === color;
            s.classList.toggle("is-active", is);
            s.setAttribute("aria-checked", is ? "true" : "false");
          });
        };
        // Keep swatches in sync when the gallery auto-advances to a tagged frame
        if (galleryFrames.length > 1) {
          const syncFromFrame = () => {
            const i = galleryFrames.findIndex((f) => f.classList.contains("is-active"));
            const c = i >= 0 ? galleryFrames[i].dataset.color : "";
            if (c) setSwatchActive(c);
          };
          galleryFrames.forEach((f) =>
            new MutationObserver(syncFromFrame).observe(f, { attributes: true, attributeFilter: ["class"] }),
          );
        }
        swatches.forEach((s) => {
          s.addEventListener("click", () => {
            const color = s.dataset.hhSwatch;
            setSwatchActive(color);
            // Jump to a tagged frame if one exists
            const target = frameColors.findIndex((c) => c === color);
            if (target >= 0) {
              const dot = root.querySelector(`[data-hh-dot="${target}"]`);
              if (dot) dot.click();
            }
          });
        });
      }

      /* Ambient drifting particle canvas, paw-print cursor trail, walk-in dog
       silhouette and magnetic cursor ring were all retired (tradeshow polish):
       on the centered turntable hero they read as noise rather than craft. The
       borderless spinning bed is the single focal point now; the grain + bloom
       carry the warmth. The turntable engine (assets/hh-bed-turntable.js) owns
       the spin, colourway crossfade and swatch picker. */
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password-splash"] && !Shopify.designMode) return;
  try {
    
(() => {
  const root = document.querySelector('[data-hh-splash]');
  if (!root) return;
  const prefersReduce = () => window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
  const canHover     = () => window.matchMedia?.('(hover: hover) and (pointer: fine)').matches;

  /* One-page no-scroll fit on mobile.
     Older iOS Safari (< 15.4) lacks dvh/svh support. Fall back to pinning
     .hh-splash to the live visualViewport.height in pixels, so the splash
     matches exactly what the user can see no matter how the address bar
     is showing/hiding. We also add .template-password-mobile to <html> so
     the CSS overflow-hidden rules kick in only on phones.               */
  const mobileMQ = window.matchMedia('(max-width: 640px)');
  const html = document.documentElement;
  const applyFit = () => {
    if (mobileMQ.matches){
      html.classList.add('template-password-mobile');
      const h = (window.visualViewport?.height || window.innerHeight);
      root.style.height = h + 'px';
      root.style.minHeight = '0';
    } else {
      html.classList.remove('template-password-mobile');
      root.style.height = '';
      root.style.minHeight = '';
    }
  };
  applyFit();
  window.addEventListener('resize', applyFit);
  window.visualViewport?.addEventListener('resize', applyFit);
  mobileMQ.addEventListener?.('change', applyFit);

  /* ============================================================
     Reactive pet scene controller.
     Each .hh-pet has --proximity (0–1) written here on every pointer
     move. CSS uses that custom prop to drive ear angle, tail wag
     speed, eye open-ness, etc. Hearts are built programmatically
     (no innerHTML) and emitted at the pet's position on proximity.
     ============================================================ */
  const scene = root.querySelector('[data-hh-scene]');
  if (scene && !prefersReduce()){
    const SVG_NS = 'http://www.w3.org/2000/svg';
    const pets = [...scene.querySelectorAll('.hh-pet')].map((el) => ({
      el,
      proximity: 0,
      lastHeartAt: 0,
    }));

    const svg = scene.querySelector('svg');

    // Convert client coords to the scene SVG's coordinate system.
    const svgPoint = (evt) => {
      const pt = svg.createSVGPoint();
      pt.x = evt.clientX; pt.y = evt.clientY;
      return pt.matrixTransform(svg.getScreenCTM().inverse());
    };

    // A pet's visual centre in SVG viewBox coords.
    // We deliberately use client-rect → svgPoint (not getBBox+getCTM), because
    // getCTM returns a matrix to the SVG's CSS-pixel viewport space, not the
    // viewBox user-coord space, which is the space svgPoint() returns. Mixing
    // the two produced bogus distances (the dog looked closer than the cat
    // when you tapped the cat). Client coords normalise through the same
    // getScreenCTM inverse the cursor uses.
    const petCentre = (petEl) => {
      const rect = petEl.getBoundingClientRect();
      const pt = svg.createSVGPoint();
      pt.x = rect.left + rect.width  / 2;
      pt.y = rect.top  + rect.height / 2;
      return pt.matrixTransform(svg.getScreenCTM().inverse());
    };

    let centres = [];
    const measure = () => { centres = pets.map(p => petCentre(p.el)); };

    // Responsive viewBox: narrow screens zoom to a tighter frame so pets
    // stay big. Mobile viewBox also CROPS the Y-axis below the pets' bodies
    // (y-max 300 instead of 400) so the cushion + feet sit offscreen —
    // matching the desktop "cut at the thighs" look the client wants on all
    // sizes. Re-measures centres after each change.
    const applyResponsiveViewBox = () => {
      const w = window.innerWidth;
      if (w < 640){
        svg.setAttribute('viewBox', '150 60 880 260');   // crops cushion/feet
      } else if (w < 900){
        svg.setAttribute('viewBox', '80 40 1040 320');   // tablet, slight crop
      } else {
        svg.setAttribute('viewBox', '0 0 1200 400');     // desktop — chrome crops
      }
      // Centres must be recomputed after viewBox changes (CTM shifts).
      requestAnimationFrame(measure);
    };
    applyResponsiveViewBox();
    window.addEventListener('resize', () => {
      applyResponsiveViewBox();
    }, { passive: true });

    // Build a heart as a small DOM+SVG tree (safe — no innerHTML, no
    // user data). One <div.hh-heart> wrapping an inline SVG heart path.
    const buildHeart = () => {
      const wrap = document.createElement('div');
      wrap.className = 'hh-heart';
      const s = document.createElementNS(SVG_NS, 'svg');
      s.setAttribute('viewBox', '0 0 24 24');
      s.setAttribute('aria-hidden', 'true');
      const path = document.createElementNS(SVG_NS, 'path');
      path.setAttribute('fill', 'currentColor');
      path.setAttribute('d', 'M 12 21 C 4 15, 1 10, 4 6 C 7 2, 11 4, 12 7 C 13 4, 17 2, 20 6 C 23 10, 20 15, 12 21 Z');
      s.appendChild(path);
      wrap.appendChild(s);
      return wrap;
    };

    const emitHeart = (pet) => {
      const rect = root.getBoundingClientRect();
      const pb = pet.el.getBoundingClientRect();
      const heart = buildHeart();
      heart.style.left = (pb.left - rect.left + pb.width / 2 - 8) + 'px';
      heart.style.top  = (pb.top  - rect.top  + 16) + 'px';
      heart.style.setProperty('--hx', (Math.random() * 30 - 15) + 'px');
      root.appendChild(heart);
      setTimeout(() => heart.remove(), 1600);
    };

    // Track the cursor in SVG coords — ONLY on devices that can hover.
    // Without hover, pointermove only fires during active drags, so any
    // updates to cursorSVG would come from taps (producing a mid-screen
    // false-positive) rather than from intent. Touch devices rely on
    // explicit taps instead.
    let cursorSVG = null;
    let lastMoveAt = performance.now();
    if (canHover()){
      root.addEventListener('pointermove', (e) => {
        cursorSVG = svgPoint(e);
        lastMoveAt = performance.now();
      });
      root.addEventListener('pointerleave', () => { cursorSVG = null; });
    }

    // Schedule a blink on each pet at random intervals (3–7s).
    const scheduleBlink = (p) => {
      const delay = 3000 + Math.random() * 4000;
      setTimeout(() => {
        p.el.classList.add('is-blink');
        setTimeout(() => p.el.classList.remove('is-blink'), 180);
        scheduleBlink(p);
      }, delay);
    };
    pets.forEach(scheduleBlink);

    /* ----------------------------------------------------------------
       Touch + auto-excite support.
       With no hover available (touch devices), cursor-proximity can't
       wake the pets — so we:
         1. On tap / pointerdown on a pet, inject a full excitement
            pulse that decays over ~2.2s (same effect as hovering).
         2. On first page visit (once), run an auto-demo that briefly
            wakes each pet in sequence so users see the reaction.
         3. Periodically repeat the auto-demo every ~20s on touch-only
            devices so the feature is always discoverable.
       ---------------------------------------------------------------- */
    // Boosts a pet's proximity artificially (overrides cursor-distance)
    // for `duration` ms, easing out. Used by both tap + auto-demo.
    const excite = (pet, duration = 2200) => {
      pet.boostUntil = performance.now() + duration;
      pet.boostStart = performance.now();
      pet.boostDuration = duration;
    };

    // Tap-to-love: each pet gets a click/pointerdown handler that
    // injects an excitement pulse AND spawns a satisfying burst of
    // hearts at the tap point, plus a short jiggle animation.
    // Burst of hearts radiating from a client-coord point.
    const heartBurst = (petEl, clientX, clientY, count = 7) => {
      const rect = root.getBoundingClientRect();
      const cx = clientX - rect.left;
      const cy = clientY - rect.top;
      for (let i = 0; i < count; i++){
        const heart = buildHeart();
        heart.classList.add('hh-heart--burst');
        const angle = -Math.PI / 2 + (Math.random() - 0.5) * 1.6; // upward spread
        const speed = 30 + Math.random() * 40;
        const dx = Math.cos(angle) * speed;
        const dy = Math.sin(angle) * speed;
        heart.style.left = (cx - 8) + 'px';
        heart.style.top  = (cy - 8) + 'px';
        heart.style.setProperty('--bx', dx + 'px');
        heart.style.setProperty('--by', dy + 'px');
        heart.style.setProperty('--hx', (Math.random() * 20 - 10) + 'px');
        heart.style.animationDelay = (i * 35) + 'ms';
        root.appendChild(heart);
        setTimeout(() => heart.remove(), 1800 + i * 35);
      }
    };

    let userHasInteracted = false;
    let demoInterval = null;

    pets.forEach((p) => {
      p.el.style.pointerEvents = 'auto';
      p.el.style.cursor = 'pointer';
      const handler = (e) => {
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        lastMoveAt = performance.now();
        // Mark user interaction so the demo stops auto-repeating.
        userHasInteracted = true;
        if (demoInterval){ clearInterval(demoInterval); demoInterval = null; }
        // Isolate the tap: any lingering boost on *other* pets is wiped,
        // and their proximity is snapped to 0 so there's no decay tail
        // that looks like a cross-activation.
        pets.forEach((other) => {
          if (other !== p){
            other.boostUntil = 0;
            other.boostStart = 0;
            other.proximity = 0;
            other.el.style.setProperty('--proximity', '0');
          }
        });
        // Don't touch cursorSVG here. On touch-only devices there's no
        // subsequent pointermove, so any value we set persists forever
        // and the cat/dog would stay "hovered" until page reload.
        // The boost system alone is enough to drive the reaction.
        excite(p);
        // Jiggle.
        p.el.classList.remove('is-tapped');
        void p.el.offsetWidth;
        p.el.classList.add('is-tapped');
        setTimeout(() => p.el.classList.remove('is-tapped'), 600);
        // Burst of hearts at the tap point.
        heartBurst(p.el, e.clientX, e.clientY);
      };
      p.el.addEventListener('pointerdown', handler);
      p.el.addEventListener('touchstart', handler, { passive: false });
    });

    // Auto-demo — one-shot reveal of the interaction. On touch-only
    // devices we also gently repeat every ~24s so users who arrive late
    // can still discover it — but only UNTIL they tap once, then the
    // interval is killed (see tap handler above).
    const runDemo = () => {
      if (userHasInteracted) return;
      pets.forEach((p, i) => {
        setTimeout(() => {
          if (!userHasInteracted) excite(p, 1600);
        }, i * 2000);
      });
    };
    setTimeout(runDemo, 1200);
    if (!canHover()){
      demoInterval = setInterval(runDemo, 28000);
    }

    // Per-frame proximity update, idle build, and heart emission.
    // Idle ramps from 0 → 1 over 8s of no cursor movement.
    // Tight proximity radius — previously 260/520 made the cat light up
    // from cursor positions on the form and tagline. Now you must be
    // genuinely close to a pet (~160 SVG units) for any reaction.
    const NEAR = 60;
    const FAR  = 160;
    const IDLE_ONSET = 2500; // ms before idle starts building
    const IDLE_FULL  = 10500; // ms for full idle
    const tickScene = (t) => {
      const sinceMove = t - lastMoveAt;
      const idleTarget = Math.max(0, Math.min(1,
        (sinceMove - IDLE_ONSET) / (IDLE_FULL - IDLE_ONSET)
      ));

      // "Nearest pet wins" — when the cursor is between pets, only the
      // closest one receives proximity. Otherwise both would fire at
      // equal distance, loving each other's energy instead of you.
      let nearestIdx = -1, nearestDist = Infinity;
      const dists = new Array(pets.length);
      if (cursorSVG){
        for (let i = 0; i < pets.length; i++){
          const dx = cursorSVG.x - centres[i].x;
          const dy = cursorSVG.y - centres[i].y;
          dists[i] = Math.hypot(dx, dy);
          if (dists[i] < nearestDist){
            nearestDist = dists[i];
            nearestIdx = i;
          }
        }
      }
      for (let i = 0; i < pets.length; i++){
        const p = pets[i];
        let target = 0;
        if (cursorSVG && i === nearestIdx){
          target = Math.max(0, Math.min(1, (FAR - dists[i]) / (FAR - NEAR)));
        }
        // Tap/demo boost — overrides cursor distance while active, easing
        // from 1 at start to 0 at boostUntil.
        if (p.boostUntil && t < p.boostUntil){
          const bt = (t - p.boostStart) / p.boostDuration;
          const boost = Math.max(0, 1 - bt);
          target = Math.max(target, boost);
          // Keep idle timer reset while excited, so pets don't sag mid-demo.
          lastMoveAt = t;
        }
        p.proximity += (target - p.proximity) * 0.12;
        if (Math.abs(target - p.proximity) < 0.001) p.proximity = target;
        p.el.style.setProperty('--proximity', p.proximity.toFixed(3));
        p.el.style.setProperty('--idle', idleTarget.toFixed(3));

        if (p.proximity > 0.5 && t - p.lastHeartAt > (380 - p.proximity * 260)){
          emitHeart(p);
          p.lastHeartAt = t;
        }
      }
      requestAnimationFrame(tickScene);
    };
    requestAnimationFrame(tickScene);
  }

  const pawCanvas = root.querySelector('[data-hh-pawtrail]');
  if (!pawCanvas || prefersReduce()) return;
  const ctx = pawCanvas.getContext('2d');
  // Walking-paws animation is off by default; toggled via section setting.
  const walkingPawsEnabled = root.dataset.walkingPaws === 'true';

  // --- Render the real logo paw twice: warm-red for the cursor trail (matches old color)
  // and dark ink for the ambient walking animation.
  const pawPaths = `
      <path d='M 116.48 9.98 C 117.24 10.11, 119.32 10.27, 120.56 10.69 C 121.80 11.11, 122.86 11.73, 123.92 12.50 C 124.99 13.27, 126.07 14.25, 126.96 15.33 C 127.85 16.41, 128.53 17.51, 129.25 18.98 C 129.97 20.45, 130.73 22.35, 131.28 24.17 C 131.83 26.00, 132.28 27.96, 132.55 29.94 C 132.81 31.92, 132.86 33.93, 132.88 36.06 C 132.89 38.20, 132.82 40.52, 132.64 42.75 C 132.46 44.99, 132.21 47.12, 131.77 49.49 C 131.33 51.86, 130.57 54.92, 130.00 56.98 C 129.43 59.05, 129.01 60.45, 128.36 61.91 C 127.71 63.36, 126.98 64.53, 126.11 65.70 C 125.24 66.88, 123.97 68.14, 123.16 68.95 C 122.34 69.76, 121.80 70.14, 121.20 70.57 C 120.61 71.01, 120.38 71.23, 119.59 71.56 C 118.81 71.88, 117.82 72.33, 116.50 72.53 C 115.18 72.73, 112.88 72.78, 111.68 72.74 C 110.48 72.71, 110.10 72.57, 109.30 72.31 C 108.50 72.05, 107.70 71.77, 106.89 71.17 C 106.08 70.58, 105.14 69.61, 104.42 68.73 C 103.70 67.85, 103.29 67.46, 102.57 65.89 C 101.85 64.33, 100.74 61.29, 100.09 59.32 C 99.45 57.36, 99.01 55.79, 98.69 54.11 C 98.37 52.42, 98.25 50.99, 98.17 49.21 C 98.09 47.43, 98.04 45.69, 98.22 43.45 C 98.40 41.21, 98.83 38.06, 99.27 35.77 C 99.70 33.48, 100.24 31.67, 100.81 29.69 C 101.38 27.70, 101.96 25.73, 102.69 23.87 C 103.41 22.01, 104.35 19.98, 105.16 18.52 C 105.96 17.05, 106.56 16.20, 107.52 15.07 C 108.49 13.94, 109.93 12.55, 110.95 11.74 C 111.98 10.93, 112.83 10.49, 113.67 10.20 C 114.52 9.90, 115.55 10.00, 116.02 9.96 C 116.48 9.93, 115.73 9.86, 116.48 9.98 Z'/>
      <path d='M 58.06 18.63 C 58.95 18.68, 61.28 18.70, 62.84 18.95 C 64.41 19.21, 65.98 19.63, 67.45 20.14 C 68.92 20.65, 70.64 21.48, 71.67 21.99 C 72.70 22.50, 73.02 22.76, 73.64 23.22 C 74.26 23.68, 74.55 23.85, 75.40 24.74 C 76.25 25.63, 77.75 27.18, 78.73 28.57 C 79.70 29.95, 80.40 31.18, 81.25 33.04 C 82.09 34.91, 83.20 37.76, 83.81 39.76 C 84.43 41.76, 84.68 43.14, 84.95 45.03 C 85.21 46.92, 85.36 49.20, 85.38 51.08 C 85.39 52.96, 85.31 54.37, 85.02 56.32 C 84.74 58.27, 84.22 60.93, 83.65 62.79 C 83.09 64.64, 82.45 66.00, 81.64 67.45 C 80.83 68.90, 79.53 70.57, 78.80 71.49 C 78.07 72.41, 77.88 72.46, 77.27 72.98 C 76.66 73.49, 75.76 74.15, 75.14 74.56 C 74.52 74.97, 74.22 75.14, 73.56 75.42 C 72.90 75.71, 72.22 76.07, 71.18 76.27 C 70.14 76.47, 68.66 76.60, 67.33 76.63 C 65.99 76.65, 64.45 76.63, 63.17 76.41 C 61.89 76.18, 60.78 75.78, 59.66 75.28 C 58.53 74.78, 57.39 74.15, 56.40 73.40 C 55.42 72.65, 54.58 71.86, 53.73 70.78 C 52.89 69.70, 52.09 68.38, 51.33 66.92 C 50.57 65.46, 49.93 63.98, 49.18 62.00 C 48.44 60.02, 47.47 57.19, 46.86 55.06 C 46.24 52.94, 45.96 51.79, 45.50 49.26 C 45.04 46.73, 44.34 42.17, 44.07 39.88 C 43.80 37.60, 43.83 37.11, 43.88 35.55 C 43.92 33.99, 44.06 32.14, 44.37 30.52 C 44.67 28.90, 45.19 27.16, 45.71 25.84 C 46.24 24.51, 46.83 23.46, 47.51 22.57 C 48.20 21.68, 49.04 21.01, 49.83 20.50 C 50.62 19.99, 51.26 19.81, 52.27 19.51 C 53.27 19.21, 55.00 18.85, 55.87 18.71 C 56.75 18.56, 57.15 18.64, 57.51 18.63 C 57.88 18.62, 57.17 18.57, 58.06 18.63 Z'/>
      <path d='M 151.17 56.48 C 151.84 56.57, 153.57 56.66, 154.58 56.96 C 155.59 57.27, 156.28 57.64, 157.23 58.30 C 158.19 58.96, 159.35 59.90, 160.32 60.91 C 161.30 61.93, 162.25 63.16, 163.08 64.38 C 163.91 65.59, 164.68 66.90, 165.32 68.20 C 165.96 69.51, 166.58 71.03, 166.95 72.21 C 167.31 73.39, 167.39 73.94, 167.53 75.28 C 167.67 76.63, 167.78 78.69, 167.78 80.27 C 167.78 81.86, 167.72 83.20, 167.54 84.80 C 167.36 86.41, 167.10 88.03, 166.69 89.88 C 166.27 91.73, 165.73 93.94, 165.05 95.90 C 164.38 97.86, 163.53 99.83, 162.61 101.66 C 161.69 103.48, 160.49 105.39, 159.52 106.86 C 158.54 108.33, 157.73 109.51, 156.78 110.47 C 155.84 111.43, 154.60 112.16, 153.84 112.64 C 153.09 113.12, 152.75 113.19, 152.23 113.35 C 151.72 113.52, 151.49 113.67, 150.75 113.63 C 150.01 113.58, 148.78 113.40, 147.82 113.10 C 146.85 112.79, 145.94 112.45, 144.97 111.81 C 144.00 111.17, 142.88 110.16, 142.02 109.27 C 141.15 108.37, 140.42 107.47, 139.78 106.45 C 139.14 105.44, 138.62 104.29, 138.18 103.17 C 137.73 102.05, 137.40 100.93, 137.13 99.73 C 136.85 98.54, 136.68 97.48, 136.55 96.02 C 136.43 94.56, 136.38 92.80, 136.38 91.00 C 136.37 89.20, 136.35 87.67, 136.49 85.20 C 136.64 82.73, 136.92 78.72, 137.26 76.19 C 137.59 73.66, 138.07 71.74, 138.50 70.02 C 138.93 68.30, 139.24 67.29, 139.86 65.87 C 140.47 64.45, 141.42 62.67, 142.18 61.48 C 142.93 60.30, 143.75 59.38, 144.39 58.75 C 145.03 58.12, 145.30 58.05, 146.03 57.68 C 146.76 57.30, 148.01 56.69, 148.77 56.48 C 149.53 56.28, 150.19 56.46, 150.59 56.46 C 150.99 56.46, 150.51 56.40, 151.17 56.48 Z'/>
      <path d='M 23.05 64.38 C 23.61 64.43, 25.09 64.46, 26.08 64.70 C 27.06 64.95, 27.74 65.25, 28.96 65.85 C 30.18 66.45, 32.08 67.45, 33.39 68.31 C 34.70 69.18, 35.69 69.97, 36.83 71.05 C 37.97 72.12, 39.19 73.51, 40.23 74.78 C 41.26 76.04, 42.26 77.48, 43.05 78.64 C 43.83 79.80, 44.27 80.51, 44.92 81.74 C 45.58 82.98, 46.32 84.45, 46.98 86.05 C 47.65 87.65, 48.39 89.64, 48.92 91.34 C 49.45 93.04, 49.87 94.76, 50.16 96.27 C 50.44 97.78, 50.59 99.06, 50.63 100.39 C 50.66 101.72, 50.57 103.08, 50.39 104.23 C 50.21 105.39, 49.87 106.51, 49.52 107.34 C 49.17 108.16, 48.83 108.70, 48.29 109.20 C 47.75 109.71, 47.20 110.10, 46.26 110.38 C 45.32 110.66, 44.06 110.87, 42.64 110.88 C 41.22 110.88, 39.40 110.73, 37.72 110.41 C 36.04 110.09, 34.09 109.50, 32.54 108.95 C 30.99 108.41, 29.83 107.88, 28.44 107.14 C 27.05 106.41, 25.53 105.49, 24.20 104.55 C 22.88 103.60, 21.61 102.57, 20.48 101.48 C 19.36 100.40, 18.34 99.21, 17.45 98.04 C 16.56 96.87, 15.92 95.85, 15.15 94.47 C 14.38 93.09, 13.47 91.27, 12.83 89.75 C 12.18 88.22, 11.67 86.81, 11.28 85.30 C 10.89 83.79, 10.57 82.22, 10.48 80.66 C 10.38 79.11, 10.50 77.43, 10.73 75.96 C 10.96 74.50, 11.53 72.84, 11.86 71.87 C 12.18 70.90, 12.39 70.63, 12.68 70.13 C 12.97 69.63, 12.98 69.48, 13.59 68.86 C 14.21 68.23, 15.55 66.99, 16.38 66.38 C 17.21 65.78, 17.52 65.57, 18.57 65.23 C 19.62 64.90, 21.94 64.52, 22.69 64.38 C 23.43 64.24, 22.48 64.32, 23.05 64.38 Z'/>
      <path d='M 90.25 75.13 C 90.74 75.14, 91.62 75.11, 92.51 75.24 C 93.40 75.38, 94.58 75.63, 95.58 75.95 C 96.59 76.26, 97.62 76.70, 98.55 77.14 C 99.49 77.59, 100.06 77.74, 101.19 78.61 C 102.32 79.48, 103.25 80.11, 105.34 82.36 C 107.42 84.62, 112.20 90.54, 113.70 92.13 C 115.21 93.71, 114.18 92.01, 114.36 91.88 C 114.54 91.74, 114.41 92.29, 114.76 91.32 C 115.10 90.34, 116.05 87.05, 116.43 86.04 C 116.81 85.04, 116.83 85.48, 117.04 85.30 C 117.25 85.12, 117.02 85.01, 117.68 84.96 C 118.33 84.90, 119.96 84.84, 120.98 84.95 C 122.01 85.07, 122.94 85.27, 123.84 85.64 C 124.75 86.02, 125.84 86.77, 126.41 87.18 C 126.98 87.59, 127.01 87.75, 127.25 88.09 C 127.49 88.44, 127.66 88.70, 127.84 89.25 C 128.03 89.80, 128.26 90.79, 128.34 91.41 C 128.42 92.02, 128.40 92.18, 128.33 92.93 C 128.25 93.68, 128.30 94.07, 127.89 95.91 C 127.47 97.74, 126.21 102.16, 125.84 103.95 C 125.46 105.75, 125.60 105.81, 125.63 106.69 C 125.65 107.57, 125.84 108.63, 125.98 109.23 C 126.12 109.83, 126.14 109.79, 126.47 110.28 C 126.79 110.77, 126.06 109.94, 127.92 112.16 C 129.78 114.38, 135.48 120.87, 137.64 123.60 C 139.81 126.33, 140.08 127.12, 140.91 128.55 C 141.74 129.97, 142.11 130.90, 142.61 132.14 C 143.11 133.38, 143.62 134.92, 143.89 135.98 C 144.16 137.05, 144.20 137.44, 144.23 138.53 C 144.27 139.61, 144.24 141.23, 144.09 142.50 C 143.95 143.77, 143.76 144.86, 143.37 146.13 C 142.98 147.40, 142.42 148.81, 141.74 150.12 C 141.06 151.43, 140.11 152.94, 139.30 154.00 C 138.50 155.06, 137.85 155.70, 136.92 156.48 C 135.99 157.27, 134.88 158.06, 133.71 158.69 C 132.54 159.32, 131.35 159.81, 129.90 160.27 C 128.45 160.74, 126.55 161.20, 125.00 161.46 C 123.46 161.73, 121.96 161.85, 120.61 161.88 C 119.26 161.90, 118.74 161.96, 116.88 161.64 C 115.02 161.32, 111.04 160.44, 109.45 159.97 C 107.86 159.51, 107.98 159.38, 107.34 158.85 C 106.71 158.33, 106.02 157.39, 105.64 156.83 C 105.27 156.27, 105.20 155.99, 105.09 155.50 C 104.99 155.01, 105.04 157.97, 104.99 153.90 C 104.94 149.83, 104.85 135.42, 104.80 131.09 C 104.74 126.76, 104.73 128.68, 104.66 127.92 C 104.58 127.16, 104.61 127.26, 104.34 126.52 C 104.07 125.79, 103.71 124.58, 103.04 123.49 C 102.36 122.41, 101.21 120.93, 100.29 120.02 C 99.37 119.12, 98.49 118.57, 97.50 118.05 C 96.50 117.52, 95.32 117.10, 94.32 116.86 C 93.32 116.62, 92.38 116.64, 91.47 116.63 C 90.56 116.61, 89.67 116.65, 88.88 116.74 C 88.09 116.83, 87.44 116.96, 86.73 117.17 C 86.02 117.38, 85.28 117.67, 84.63 117.99 C 83.97 118.32, 83.38 118.69, 82.80 119.13 C 82.21 119.57, 81.62 120.11, 81.11 120.64 C 80.60 121.18, 80.19 121.71, 79.76 122.34 C 79.34 122.97, 78.90 123.71, 78.56 124.43 C 78.22 125.16, 77.87 126.02, 77.70 126.67 C 77.54 127.33, 77.64 123.89, 77.55 128.37 C 77.46 132.85, 77.34 148.99, 77.16 153.55 C 76.98 158.11, 76.80 155.20, 76.47 155.73 C 76.15 156.27, 75.73 156.48, 75.21 156.74 C 74.70 157.00, 75.46 156.96, 73.40 157.30 C 71.34 157.64, 65.91 158.53, 62.87 158.78 C 59.83 159.03, 57.20 158.90, 55.17 158.80 C 53.13 158.71, 52.05 158.58, 50.66 158.22 C 49.26 157.85, 47.99 157.27, 46.81 156.61 C 45.63 155.95, 44.54 155.15, 43.58 154.23 C 42.62 153.32, 41.87 152.44, 41.05 151.11 C 40.23 149.77, 39.20 147.67, 38.66 146.24 C 38.12 144.81, 37.94 144.06, 37.81 142.53 C 37.68 141.01, 37.77 138.49, 37.89 137.09 C 38.01 135.69, 38.14 135.20, 38.53 134.13 C 38.93 133.05, 39.19 132.09, 40.25 130.67 C 41.31 129.26, 42.15 128.19, 44.88 125.64 C 47.62 123.10, 53.89 118.01, 56.66 115.39 C 59.43 112.77, 60.34 111.39, 61.52 109.90 C 62.71 108.41, 62.99 107.76, 63.75 106.45 C 64.51 105.15, 65.01 104.44, 66.11 102.05 C 67.20 99.67, 69.23 94.58, 70.31 92.16 C 71.39 89.75, 71.80 88.98, 72.57 87.55 C 73.35 86.11, 74.20 84.69, 74.95 83.56 C 75.71 82.44, 76.29 81.67, 77.10 80.79 C 77.91 79.91, 78.97 78.94, 79.82 78.28 C 80.67 77.63, 80.92 77.36, 82.21 76.85 C 83.49 76.34, 86.29 75.52, 87.52 75.23 C 88.75 74.95, 89.13 75.15, 89.59 75.13 C 90.05 75.11, 89.76 75.11, 90.25 75.13 Z'/>
  `;
  const pawSvg = (hex) => `<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 185 179'><g fill='${hex}'>${pawPaths}</g></svg>`;
  const loadPaw = (hex) => {
    const img = new Image();
    img.src = 'data:image/svg+xml;utf8,' + pawSvg(hex).replace(/\n\s+/g, ' ');
    return img;
  };
  // Warm terracotta red used on the previous paw cursor trail.
  const pawImgRed = loadPaw('%23b8452c');
  // Dark ink paw for ambient "walking home" animation (subtle, in the background).
  const pawImgInk = loadPaw('%231a1814');

  const state = {
    trail: [],      // cursor-trail paws
    walkers: [],    // periodic walking paws
    leftFoot: true,
    lastX: 0, lastY: 0, lastDropAt: 0,
    nextWalkAt: 0,
  };

  const resize = () => {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const r = root.getBoundingClientRect();
    pawCanvas.width  = Math.max(1, r.width  * dpr);
    pawCanvas.height = Math.max(1, r.height * dpr);
    pawCanvas.style.width  = r.width + 'px';
    pawCanvas.style.height = r.height + 'px';
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  };
  resize();
  window.addEventListener('resize', resize, { passive: true });

  const drawPaw = (img, x, y, angle, alpha, size = 22) => {
    if (!img.complete || !img.naturalWidth) return;
    ctx.save();
    ctx.globalAlpha = alpha;
    ctx.translate(x, y);
    ctx.rotate(angle);
    ctx.drawImage(img, -size / 2, -size / 2, size, size);
    ctx.restore();
  };

  // Cursor trail: only if fine pointer.
  if (canHover()){
    root.addEventListener('pointermove', (e) => {
      const r = root.getBoundingClientRect();
      const x = e.clientX - r.left, y = e.clientY - r.top;
      const dx = x - state.lastX, dy = y - state.lastY;
      const dist = Math.hypot(dx, dy);
      const now = performance.now();
      if (dist > 34 && now - state.lastDropAt > 70){
        const angle = Math.atan2(dy, dx) + Math.PI / 2;
        const perp = angle + Math.PI / 2;
        const offset = state.leftFoot ? -11 : 11;
        state.trail.push({
          x: x + Math.cos(perp) * offset,
          y: y + Math.sin(perp) * offset,
          angle,
          born: now,
          size: 22,
          life: 1600,
        });
        state.leftFoot = !state.leftFoot;
        state.lastDropAt = now;
        state.lastX = x; state.lastY = y;
      }
    });
  }

  // Walker: periodically spawn a trail of paws striding across the canvas.
  // Organic curve so it feels like a real pet path, not a straight line.
  const spawnWalker = () => {
    const r = root.getBoundingClientRect();
    const dir = Math.random() < 0.5 ? 1 : -1;                 // 1 = L→R (coming home), -1 = R→L
    const yBase = r.height * (0.62 + Math.random() * 0.28);   // lower portion
    const amp   = 18 + Math.random() * 26;                    // wobble amplitude
    const freq  = 0.0055 + Math.random() * 0.0035;            // wobble frequency
    const stepLen = 46;                                       // distance between steps
    const steps = Math.ceil((r.width + 160) / stepLen);
    const now = performance.now();
    const stagger = 140;                                      // ms between steps
    const life    = 2600;                                     // ms each paw lives
    const size = 18 + Math.random() * 6;
    let leftFoot = true;

    for (let i = 0; i < steps; i++){
      const progress = i * stepLen;
      const x = dir === 1 ? -80 + progress : r.width + 80 - progress;
      const y = yBase + Math.sin(progress * freq) * amp;

      // Tangent direction for this footprint.
      const dxT = dir;
      const dyT = Math.cos(progress * freq) * amp * freq * (dir);
      const angle = Math.atan2(dyT, dxT) + Math.PI / 2;

      // Offset perpendicular to walking direction for left/right foot alternation.
      const perp = angle + Math.PI / 2;
      const offset = leftFoot ? -10 : 10;
      leftFoot = !leftFoot;

      state.walkers.push({
        x: x + Math.cos(perp) * offset,
        y: y + Math.sin(perp) * offset,
        angle,
        born: now + i * stagger,
        size,
        life,
      });
    }
  };

  const tick = (t) => {
    const r = root.getBoundingClientRect();
    ctx.clearRect(0, 0, r.width, r.height);

    // Spawn a walker every 5–9s (only when the section setting enables it).
    if (walkingPawsEnabled && t >= state.nextWalkAt){
      spawnWalker();
      state.nextWalkAt = t + 5000 + Math.random() * 4000;
    }

    // Cursor trail — warm-red paw, stronger on top.
    for (let i = state.trail.length - 1; i >= 0; i--){
      const p = state.trail[i];
      const age = t - p.born;
      if (age < 0) continue;
      if (age > p.life){ state.trail.splice(i, 1); continue; }
      const n = age / p.life;
      const alpha = Math.max(0, 1 - n) * 0.55;
      drawPaw(pawImgRed, p.x, p.y, p.angle, alpha, p.size);
    }

    // Walking paws — softer dark ink, in the background.
    for (let i = state.walkers.length - 1; i >= 0; i--){
      const p = state.walkers[i];
      const age = t - p.born;
      if (age < 0) continue;
      if (age > p.life){ state.walkers.splice(i, 1); continue; }
      const n = age / p.life;
      const alpha = (n < 0.12 ? n / 0.12 : 1 - (n - 0.12) / 0.88) * 0.18;
      drawPaw(pawImgInk, p.x, p.y, p.angle, alpha, p.size);
    }

    requestAnimationFrame(tick);
  };
  requestAnimationFrame(tick);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Single-open behavior for accordions marked data-hh-accordion="true"
    document.querySelectorAll('.hh-faq__list[data-hh-accordion="true"]').forEach((list) => {
      list.addEventListener(
        "toggle",
        (e) => {
          const tgt = e.target;
          if (!(tgt instanceof HTMLDetailsElement)) return;
          const sum = tgt.querySelector("summary");
          if (sum) sum.setAttribute("aria-expanded", tgt.open ? "true" : "false");
          if (!tgt.open) return;
          list.querySelectorAll("details[open]").forEach((d) => {
            if (d !== tgt) d.removeAttribute("open");
          });
        },
        true,
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bar = document.querySelector("[data-hh-sticky-atc]");
    if (!bar) return;
    const mainForm = document.getElementById("ProductForm");
    // Prefer watching the main ATC button/form directly; fall back to gallery.
    const watchTarget =
      document.querySelector("[data-hh-atc]") ||
      mainForm?.querySelector('[name="add"], button[type="submit"]') ||
      mainForm ||
      document.querySelector(".hh-product__media, .product-gallery, [data-product-gallery]");

    // Desktop hide breakpoint: when there's plenty of room, main ATC stays visible; no sticky needed.
    const desktopMQ = window.matchMedia("(min-width: 1024px)");

    let hideTimer = null;
    const show = () => {
      if (desktopMQ.matches) return; // mobile-first; desktop keeps main ATC in view
      // Cancel any pending hide so a quick direction change cannot re-hide
      // the bar right after it becomes visible.
      if (hideTimer) {
        clearTimeout(hideTimer);
        hideTimer = null;
      }
      if (!bar.hidden && bar.classList.contains("is-visible")) return;
      bar.hidden = false;
      // next frame so the transform transition plays
      requestAnimationFrame(() => {
        bar.classList.add("is-visible");
        bar.setAttribute("aria-hidden", "false");
        document.body.classList.add("hh-sticky-atc--visible");
      });
    };
    const hide = () => {
      if (bar.hidden && !bar.classList.contains("is-visible")) return;
      bar.classList.remove("is-visible");
      bar.setAttribute("aria-hidden", "true");
      document.body.classList.remove("hh-sticky-atc--visible");
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(() => {
        bar.hidden = true;
        hideTimer = null;
      }, 500);
    };

    // Position check on scroll. An IntersectionObserver alone misses instant
    // jumps (anchor links like #reviews, programmatic scrollTo) because the
    // watched ATC button never paints inside the viewport, so no threshold
    // crossing fires and the bar never appears. An rAF-throttled scroll
    // listener reading one getBoundingClientRect is cheap and catches every
    // case, so it replaces the observer outright.
    if (watchTarget) {
      let ticking = false;
      const evaluate = () => {
        ticking = false;
        const r = watchTarget.getBoundingClientRect();
        // ATC fully above the viewport (60px header allowance) -> show sticky
        if (r.bottom < 60) show();
        else hide();
      };
      const onScroll = () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(evaluate);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll, { passive: true });
      evaluate();
    } else {
      // Fallback: show after 400px scroll
      window.addEventListener(
        "scroll",
        () => {
          if (window.scrollY > 400) show();
          else hide();
        },
        { passive: true },
      );
    }

    // If viewport crosses the desktop breakpoint while visible, hide.
    desktopMQ.addEventListener?.("change", (ev) => {
      if (ev.matches) hide();
    });

    // Mirror the main product price into the sticky bar on variant change.
    // The bar is server-rendered once for the first variant, but size changes
    // the bed price (S/M/L), so a stale sticky price could show a different
    // figure than the cart charges. Read-only mirror of the main [data-price].
    const mainPrice = document.querySelector("[data-price]");
    const stickyPrice = bar.querySelector("[data-sticky-price]");
    if (mainPrice && stickyPrice) {
      const mirrorPrice = () => {
        const cur = mainPrice.querySelector(".hh-price__current");
        if (!cur) return;
        const cmp = mainPrice.querySelector(".hh-price__compare");
        stickyPrice.textContent = "";
        const c = document.createElement("span");
        c.textContent = cur.textContent.trim();
        stickyPrice.appendChild(c);
        if (cmp && cmp.textContent.trim()) {
          const s = document.createElement("s");
          s.textContent = cmp.textContent.trim();
          stickyPrice.appendChild(document.createTextNode(" "));
          stickyPrice.appendChild(s);
        }
      };
      new MutationObserver(mirrorPrice).observe(mainPrice, { childList: true, subtree: true, characterData: true });
      mainForm?.addEventListener("change", () => requestAnimationFrame(mirrorPrice));
    }

    // Quantity controls. Clamp to the input's max (variant stock) when set;
    // the max attribute is server-rendered and updated on variant change by
    // the product-form script in sections/main-product.liquid.
    const qtyInput = bar.querySelector("[data-qty-input]");
    const clampQty = (n) => {
      const max = parseInt(qtyInput?.max || "", 10);
      if (!isNaN(max) && max > 0 && n > max) n = max;
      return Math.max(1, n);
    };
    bar.querySelector("[data-qty-dec]")?.addEventListener("click", () => {
      qtyInput.value = clampQty(parseInt(qtyInput.value || "1", 10) - 1);
    });
    bar.querySelector("[data-qty-inc]")?.addEventListener("click", () => {
      qtyInput.value = clampQty(parseInt(qtyInput.value || "1", 10) + 1);
    });
    qtyInput?.addEventListener("change", () => {
      qtyInput.value = clampQty(parseInt(qtyInput.value || "1", 10));
    });

    // ATC: fetch /cart/add with current variant + qty, then refresh + open cart drawer
    const atcBtn = bar.querySelector("[data-sticky-atc-button]");
    const atcLabel = bar.querySelector("[data-sticky-atc-label]");
    atcBtn?.addEventListener("click", async () => {
      const variantInput = mainForm?.querySelector('[name="id"], [data-variant-id]');
      const id = variantInput?.value;
      if (!id) {
        window.location.href = bar.dataset.productUrl || "/";
        return;
      }
      const qty = clampQty(parseInt(qtyInput?.value || "1", 10));
      const original = atcLabel ? atcLabel.textContent : "";
      atcBtn.disabled = true;
      atcBtn.setAttribute("aria-busy", "true");
      if (atcLabel) atcLabel.textContent = "Adding";
      try {
        const resp = await fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8", Accept: "application/json" },
          body: new URLSearchParams({ id, quantity: String(qty) }).toString(),
        });
        if (!resp.ok) {
          let msg = "Sorry, we could not add that. It may be sold out.";
          try {
            const ed = await resp.json();
            if (ed && ed.description) msg = ed.description;
          } catch (_e) {}
          try {
            document.dispatchEvent(new CustomEvent("hh:toast", { detail: { message: msg, kind: "error" } }));
          } catch (_e) {}
          return;
        }
        try {
          if (window.HH && window.HH.events) {
            window.HH.events.track("cart_add", { variant_id: id, surface: "sticky" });
            window.HH.events.track("cart_updated", { source: "add", surface: "sticky", variant_id: id });
          }
        } catch (_e) {}
        // Let global.js pick up via cart refresh; best-effort trigger
        const cartLink = document.querySelector('.hh-header a[href*="/cart"]');
        if (cartLink) cartLink.click();
      } catch (err) {
        console.error("sticky atc add failed", err);
        try {
          document.dispatchEvent(
            new CustomEvent("hh:toast", { detail: { message: "Network hiccup. Please try again.", kind: "error" } }),
          );
        } catch (_e) {}
      } finally {
        atcBtn.disabled = false;
        atcBtn.removeAttribute("aria-busy");
        if (atcLabel) atcLabel.textContent = original;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rescue-stats"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    const targets = document.querySelectorAll("[data-hh-countup]");
    if (!targets.length) return;

    // If motion is reduced, ensure final values are shown and stop.
    if (reduce) {
      targets.forEach((el) => {
        const raw = el.getAttribute("data-hh-countup-raw");
        if (raw) el.textContent = raw;
      });
      return;
    }

    const formatMatch = (raw, n) => {
      if (!raw) return String(Math.round(n));
      // Preserve prefix/suffix around the numeric token (e.g. "&euro;4,200", "127+").
      const m = String(raw).match(/^(\D*)([\d.,]+)(.*)$/);
      if (!m) return String(Math.round(n));
      const [, prefix, num, suffix] = m;
      const hasComma = num.includes(",");
      const formatted = hasComma ? Math.round(n).toLocaleString("en-US") : String(Math.round(n));
      return `${prefix}${formatted}${suffix}`;
    };

    const ease = (t) => {
      // cubic-bezier(.16, 1, .3, 1) approximation :: easeOutExpo-ish.
      return 1 - Math.pow(1 - t, 4);
    };

    const run = (el) => {
      const target = parseFloat(el.getAttribute("data-hh-countup-target")) || 0;
      const raw = el.getAttribute("data-hh-countup-raw") || "";
      if (el.dataset.hhCountupDone === "1") return;
      el.dataset.hhCountupDone = "1";
      const duration = 1800;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const current = ease(t) * target;
        el.textContent = formatMatch(raw, current);
        if (t < 1) requestAnimationFrame(step);
        else el.textContent = raw;
      };
      requestAnimationFrame(step);
    };

    if ("IntersectionObserver" in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              run(entry.target);
              io.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.4 },
      );
      targets.forEach((el) => io.observe(el));
    } else {
      targets.forEach(run);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
